import { ICardProductFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/cardProductFormMeta';
import { ICardProgramFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/cardProgramFormMeta';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
    meta: ICardProgramFormMeta
} & Partial<TFormUIProps>;

const CardProgramFormUI: React.FC<Props> = ({ isLoading, meta }) => {

    const { register, formState: {errors} } = useFormContext();
    
    return (
        <CC.Box mb={14}>
            <CC.SimpleGrid columns={{base: 1, md: 2, lg:3}} spacing={10} my={10}>
                {displayCustomInputs<ICardProgramFormMeta>(meta, register, errors, isLoading)}
            </CC.SimpleGrid>

            {/* <CC.SimpleGrid columns={{base: 1, md: 2, lg:3}} spacing={10} my={10}>
                {displayCustomInputs<ICardProductFormMeta>(meta, register, errors, isLoading, [], [meta.bankId?.name!, meta.bank?.name!, meta.preparationDate?.name!])}
            </CC.SimpleGrid>

            <CustomFormControl isLoading={isLoading} label={meta.preparationDate?.label!} isInvalid={!!errors[meta.preparationDate?.name!]} w={{base: 'full', lg: '50%'}}>
                <CustomInput hasError={errors[meta.preparationDate?.name!]} register={register(meta.preparationDate?.name!)} meta={meta.preparationDate!}/>

            </CustomFormControl> */}
        </CC.Box>
    );
};

export default CardProgramFormUI;
